import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
// import PostAddIcon from '@material-ui/icons/PostAdd'
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import AddIcon from '@material-ui/icons/Add';
import '../Timeline.css';
var image1 = 'https://images.unsplash.com/photo-1565822737580-090f3d63b27d?ixlib=rb-1.2.1&w=1000&q=80';
var image2 = 'https://images.unsplash.com/photo-1565822737580-090f3d63b27d?ixlib=rb-1.2.1&w=1000&q=80';
var image3 = 'https://images.unsplash.com/photo-1565822737580-090f3d63b27d?ixlib=rb-1.2.1&w=1000&q=80';
var title1 = 'Create Designer Account';
var title2 = 'Upload Designs';
var title3 = 'Sit back and chill while we work';
var message1 = 'Simply fill out the Designer Setup form under Profile';
var message2 = 'Post your designs directly from your mobile device or Computer';
var message3 = 'Mail in your inventory to the HullThread Warehouse, or if you are within range set up a date for our Design Transport service to pick up your inventory';
var Designer = function () {
    return (React.createElement("div", { className: 'timelineMain' },
        React.createElement(VerticalTimeline, null,
            React.createElement(VerticalTimelineElement, { className: 'vertical-timeline-element--work', contentStyle: { background: 'rgb(33, 150, 243)', color: '#fff' }, contentArrowStyle: { borderRight: '7px solid  rgb(33, 150, 243)' }, iconStyle: { background: 'rgb(33, 150, 243)', color: '#fff' }, icon: React.createElement(AccountCircleIcon, null) },
                React.createElement("h3", { style: { color: 'white' }, className: 'vertical-timeline-element-title' }, "Create a Designer Account"),
                React.createElement("p", null, message1)),
            React.createElement(VerticalTimelineElement, { className: 'vertical-timeline-element--work', contentStyle: { background: '#6f6f6f', color: '#fff' }, contentArrowStyle: { borderRight: '7px solid  #6f6f6f' }, iconStyle: { background: '#6f6f6f', color: '#fff' }, icon: React.createElement(AddIcon, null) },
                React.createElement("h3", { style: { color: 'white' }, className: 'vertical-timeline-element-title' }, "Post Your Designs"),
                React.createElement("p", null, message2)),
            React.createElement(VerticalTimelineElement, { className: 'vertical-timeline-element--work', contentStyle: { background: 'rgb(33, 150, 243)', color: '#fff' }, contentArrowStyle: { borderRight: '7px solid  rgb(33, 150, 243)' }, iconStyle: { background: 'rgb(33, 150, 243)', color: '#fff' }, icon: React.createElement(LocalShippingIcon, null) },
                React.createElement("h3", { style: { color: 'white' }, className: 'vertical-timeline-element-title' }, "Send your inventory"),
                React.createElement("p", null, message3)))));
};
export default Designer;



//////////////////
// WEBPACK FOOTER
// ./src/containers/FrontPg/ImageCarousel/PublicDisplay/Designer/Designer.tsx
// module id = 1536
// module chunks = 0 1 2 3